import moment from "moment";
import { useMemo } from "react";

type MonthYearListProps = {
  startDate: Date;
  endDate: Date;
  onChange?: (fromDate: Date, toDate: Date) => void;
  selectedDateRangeStart?: Date;
  selectedDateRangeEnd?: Date;
};

type MonthYearInstance = {
  id: number;
  startDate: Date;
  endDate: Date;
};

const getMonths = (date: Date) => date.getFullYear() * 12 + date.getMonth();

export function MonthYearList({
  startDate,
  endDate,
  onChange,
  selectedDateRangeStart,
  selectedDateRangeEnd,
}: MonthYearListProps) {
  const finalEndDate = useMemo(
    () => new Date(endDate.getFullYear(), endDate.getMonth() + 1),
    [endDate]
  );

  const monthYearInstances = useMemo<MonthYearInstance[]>(() => {
    const myInstancesCount = getMonths(finalEndDate) - getMonths(startDate);
    const allInstances = new Array(myInstancesCount).fill("").map((_, idx) => ({
      id: getMonths(startDate) + idx,
      startDate: new Date(startDate.getFullYear(), startDate.getMonth() + idx),
      endDate: new Date(
        startDate.getFullYear(),
        startDate.getMonth() + idx + 1
      ),
    }));
    return allInstances.slice(-3);
  }, [startDate, finalEndDate]);

  const isTodaySelected =
    selectedDateRangeStart?.getTime() === new Date().setHours(0, 0, 0, 0) &&
    selectedDateRangeEnd?.getTime() === new Date().setHours(23, 59, 59, 999);

  const handleTodayFilter = () => {
    if (typeof onChange === "function") {
      const today = new Date();
      const startOfDay = new Date(today.setHours(0, 0, 0, 0));
      const endOfDay = new Date(today.setHours(23, 59, 59, 999));
      if (isTodaySelected) {
        onChange(startDate, endDate);
      } else {
        onChange(startOfDay, endOfDay);
      }
    }
  };
  return (
    <>
      {monthYearInstances.map((myi) => {
        const isInstanceSelected =
          selectedDateRangeStart?.getTime() === myi.startDate.getTime() &&
          selectedDateRangeEnd?.getTime() === myi.endDate.getTime();

        return (
          <div
            onClick={() => {
              if (typeof onChange === "function") {
                if (isInstanceSelected) onChange(startDate, endDate);
                else onChange(myi.startDate, myi.endDate);
              }
            }}
            className={`flex flex-col h-20 w-20 rounded-lg justify-center items-center font-semibold cursor-pointer ${
              isInstanceSelected
                ? "bg-gray-700 text-white"
                : "border-2 border-gray-300 text-gray-700"
            }`}
          >
            <span className="text-xl">
              {moment(myi.startDate).format("MMM")}
            </span>
            <span>{moment(myi.startDate).format("Y")}</span>
          </div>
        );
      })}
      <div
        onClick={handleTodayFilter}
        className={`flex flex-col h-20 w-20 rounded-lg justify-center items-center font-semibold cursor-pointer ${
          isTodaySelected
            ? "bg-gray-700 text-white"
            : "border-2 border-gray-300 text-gray-700"
        }`}
      >
        <span className={`text-xl`}>Today</span>
      </div>
    </>
  );
}
